<template>
  <div>
    <!-- 加载层添加图标和文字提示 -->
    <van-overlay v-show="loading" class="loading-overlay">
      <div class="loading-content">
        <van-loading type="spinner" color="#fff" />
        <p class="loading-text">加载中...</p>
      </div>
    </van-overlay>

    <van-tabs ref="vanTabs" v-model="activeTab" sticky animated :swipeable="swipeableEnabled">

      <van-tab title="韭菜" name="tab_ty_jiucai_search">
        <div class="mgt20">
          <van-field
            v-model="search_keyword"
            label="标题"
            label-width="120px"
            placeholder="“+”加号且，“ ”空格或"
            maxlength="50"
          />
        </div>
        <div class="mgt20">
            <label>{{keywords_history}}</label>
        </div>
        <div class="jiucai_zone mgt20">
          <div v-html="xinde_result[0]"></div>
          <div v-html="xinde_result[1]"></div>
          <div v-html="xinde_result[2]"></div>
          <div v-html="xinde_result[3]"></div>
        </div>
        <div class="btn_zone mgt20">
          <div>文章数: {{tab_ty_jiucai_search_result.length}}</div>
          <van-button @click="onBtnXindeClick" round type="primary">心得|心得 心得|心得</van-button>
          <van-button @click="onBtnTyJiucaiSearch" round type="primary">查询</van-button>
          <van-button @click="onBtnTyJiucaiSearchAll" round type="primary">ALL</van-button>
        </div>
        <div class="jiucai_zone mgt20">
          <div
            v-for="(item, index) in tab_ty_jiucai_search_result"
            :key="index"
            :class="{ 'even-item': index % 2 === 0, 'odd-item': index % 2 === 1 }"
          >
            <div><a class="black-link" :href="item.link" @click="(e) => openNewTab(e, item.link)" >{{item.pub_time}} 《<span v-html="item.title"></span>》</a></div>
          </div>
        </div>
      </van-tab>

      <!-- 循环生成天梯Tab -->
      <van-tab
        v-for="tabConfig in tiantiTabConfigs"
        :key="tabConfig.name"
        :title="`${tabConfig.title}(${getTiantiListLength(tabConfig.listKey[0])})`"
        :name="tabConfig.name"
      >
        <div class="tips_zone">
          {{tabConfig.tips}}
        </div>
        <div
          class="tip_zone"
          v-for="(listKey, listIndex) in tabConfig.listKey"
          :key="listIndex"
        >
          <div
            v-for="(item, index) in getTiantiList(listKey)"
            :key="item.stock_code"
            @click="seeTyDetail($event, item.stock_code)"
            v-longpress="(e) => handleLongPress(e, item.stock_code, item.stock_name)"
            :class="{ 'zf-even-item': index % 2 === 0, 'zf-odd-item': index % 2 === 1 }"
          >
            <div>今日: <span :class="{ 'red-text': item.zf_today >= 0, 'green-text': item.zf_today < 0 }">{{item.zf_today}}%</span> <span :class="{ 'blue-text': item.today_percent >= 19 }"><b>{{item.stock_code}}</b></span> <span class="stock-name-clickable" @click.stop="openTagsDialog(item.stock_code, item.stock_name, item.tags)" @touchstart.capture.stop="onStockNameTouchStart" @touchend="onStockNameTouchEnd($event, item.stock_code, item.stock_name, item.tags)" @mousedown.stop v-html="`<b>${item.stock_name}</b>`"></span><span class="tags-display" v-if="item.tags"><sup v-for="(tag, tagIndex) in item.tags.split(',')" :key="tagIndex" class="tag-item">{{tag}}</sup></span> <a :href="item.jiucai_yidong_link" target="_blank">{{item.lianban_info}}</a> <span v-if="item.jc_yidong">+</span></div>
            <div><span class="blue-text">{{item.flag_text}}</span> </div>
            <div>当前: <span :class="{ 'red-text': item.today_percent >= 0, 'green-text': item.today_percent < 0 }">{{item.today_percent}}%</span> / {{item.today_price}} / {{item.today_flow_market_capital}} </div>
            <div v-show="expandedIndex === item.stock_code">
              <div>{{item.jc_yidong}}</div>
            </div>
          </div>
        </div>
      </van-tab>

      <!-- 循环生成涨幅Tab -->
      <van-tab
        v-for="tabConfig in zhangfuTabConfigs"
        :key="tabConfig.name"
        :title="`${tabConfig.title}`"
        :name="tabConfig.name"
      >
        <div class="tips_zone">
          {{tabConfig.tips}}
        </div>
        <div
          class="tip_zone"
          v-for="(listKey, listIndex) in tabConfig.listKey"
          :key="listIndex"
        >
          <div
            v-for="(item, index) in getZhangfuList(listKey)"
            :key="item.stock_code"
            @click="seeTyDetail($event, item.stock_code)"
            :class="{ 'zf-even-item': index % 2 === 0, 'zf-odd-item': index % 2 === 1 }"
          >
            <div>{{tabConfig.title}}: <span :class="{ 'blue-text': item.zf >= 50, 'red-text': item.zf >= 0 && item.zf < 50, 'green-text': item.zf < 0 }">{{item.zf}}%</span> <span :class="{ 'blue-text': item.today_percent >= 19 }"><b>{{item.stock_code}}</b></span> <span class="stock-name-clickable" @click.stop="openTagsDialog(item.stock_code, item.stock_name, item.tags)" @touchstart.capture.stop="onStockNameTouchStart" @touchend="onStockNameTouchEnd($event, item.stock_code, item.stock_name, item.tags)" @mousedown.stop v-html="`<b>${item.stock_name}</b>`"></span><span class="tags-display" v-if="item.tags"><sup v-for="(tag, tagIndex) in item.tags.split(',')" :key="tagIndex" class="tag-item">{{tag}}</sup></span> <a :href="item.jiucai_yidong_link" target="_blank">{{item.lianban_info}}</a> <span v-if="item.jc_yidong">+</span></div>
            <div><span class="blue-text">{{item.flag_text}}</span> </div>
            <div>当前: <span :class="{ 'red-text': item.today_percent >= 0, 'green-text': item.today_percent < 0 }">{{item.today_percent}}%</span> / {{item.today_price}} / {{item.today_flow_market_capital}} </div>
            <div v-show="expandedIndex === item.stock_code">
              <div>{{item.jc_yidong}}</div>
            </div>
          </div>
        </div>
      </van-tab>

      <!-- 交易记录Tab -->
      <van-tab title="交易" name="tab_trade">
        <div class="trade_zone">
          <div class="btn_zone mgt20">
            <van-button @click="openAddTradeDialog" round type="primary">添加记录</van-button>
          </div>
          <div class="trade_list mgt20">
            <div
              v-for="(item, index) in trade_records"
              :key="item.id"
              :class="{ 'even-item': index % 2 === 0, 'odd-item': index % 2 === 1 }"
              @click="openEditTradeDialog(item)"
            >
              <div><b>{{formatTradeDate(item.trade_date)}}</b> {{item.stock_name}} <span v-if="item.buy_reason">{{item.buy_reason}}</span> <span :class="getProfitLossClass(item.profit_percent)">{{item.profit_percent}}</span></div>
              <div v-if="item.advantage">优势: {{item.advantage}}</div>
              <div v-if="item.disadvantage">劣势: {{item.disadvantage}}</div>
            </div>
          </div>
        </div>
      </van-tab>

    </van-tabs>

    <!-- 长按操作弹窗 -->
    <div
      v-if="longPressDialog"
      class="longpress-popup"
      :style="{ top: popupTop + 'px', left: popupLeft + 'px' }"
      @click.stop
    >
      <div class="popup-content">
        <button
          class="popup-btn add-btn"
          @click="operatePopularity('add_renqi')"
        >
          添加人气
        </button>
        <button
          class="popup-btn remove-btn"
          @click="operatePopularity('remove_renqi')"
        >
          移除人气
        </button>
      </div>
      <!-- 点击空白处关闭弹窗 -->
      <div class="popup-mask" @click="cancelOperate"></div>
    </div>

    <!-- 标签编辑弹窗 -->
    <van-overlay v-show="tagsDialogVisible" class="tags-overlay" @click="closeTagsDialog">
      <div class="tags-dialog" @click.stop>
        <div class="tags-dialog-title">编辑标签 - <span v-html="tagsStockName"></span></div>
        <div class="tags-dialog-content">
          <van-field
            v-model="tagsInputValue"
            label="标签"
            placeholder="多个标签用英文逗号分隔"
            maxlength="100"
          />
        </div>
        <div class="tags-dialog-footer">
          <van-button size="small" @click="closeTagsDialog">取消</van-button>
          <van-button size="small" type="primary" @click="saveTags">保存</van-button>
        </div>
      </div>
    </van-overlay>

    <!-- 交易记录编辑弹窗 -->
    <van-overlay v-show="show_trade_dialog" class="tags-overlay" @click="closeTradeDialog">
      <div class="trade-dialog" @click.stop>
        <div class="tags-dialog-title">{{is_edit_mode ? '编辑' : '添加'}}交易记录</div>
        <div class="tags-dialog-content">
          <van-field
            v-model="trade_form.trade_date"
            label="交易日期"
            placeholder="YYYY-MM-DD"
            maxlength="10"
          />
          <van-field
            v-model="trade_form.stock_name"
            label="股票名称"
            placeholder=""
            maxlength="100"
          />
          <van-field
            v-model="trade_form.buy_reason"
            label="买入理由"
            placeholder="直接输入或点击右侧选择"
            maxlength="200"
          >
            <template #button>
              <van-button size="small" type="primary" @click="showReasonPicker = true">选择</van-button>
            </template>
          </van-field>
          <van-field
            v-model="trade_form.advantage"
            label="优势"
            type="textarea"
            placeholder="请输入优势"
            rows="2"
            maxlength="500"
          />
          <van-field
            v-model="trade_form.disadvantage"
            label="劣势"
            type="textarea"
            placeholder="请输入劣势"
            rows="2"
            maxlength="500"
          />
          <van-field
            v-model="trade_form.profit_percent"
            label="盈亏百分比"
            placeholder="如：+10.5 或 -5.2"
            maxlength="20"
          />
        </div>
        <div class="tags-dialog-footer">
          <van-button size="small" @click="closeTradeDialog">取消</van-button>
          <van-button v-if="is_edit_mode" size="small" type="danger" @click="deleteTradeRecord">删除</van-button>
          <van-button size="small" type="primary" @click="saveTradeRecord">保存</van-button>
        </div>
      </div>
    </van-overlay>

    <!-- 买入理由选择器 -->
    <van-popup v-model="showReasonPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="reasonPickerColumns"
        @confirm="onReasonConfirm"
        @cancel="showReasonPicker = false"
      />
    </van-popup>

  </div>
</template>

<script>
import {Field, Tab, Tabs, Checkbox, CheckboxGroup, RadioGroup, Radio, Button, Notify, Divider, Overlay, DropdownMenu, DropdownItem, Row, Col, Dialog, Popup, Picker} from 'vant';

export default {
  components: {
    [Field.name]: Field,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Overlay.name]: Overlay,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  // 在组件的 directives 选项中定义长按指令
  directives: {
    // v-longpress 长按指令
    longpress: {
      bind(el, binding) {
        if (typeof binding.value !== 'function') {
          throw 'callback must be a function';
        }
        // 定义变量
        let pressTimer = null;
        // 创建计时器
        const start = (e) => {
          // 排除点击事件
          if (e.type === 'click' && e.button !== 0) {
            return;
          }
          if (pressTimer === null) {
            pressTimer = setTimeout(() => {
              // 执行长按回调
              binding.value(e);
            }, 4000); // 长按时间设为4000毫秒
          }
        };
        // 取消计时器
        const cancel = () => {
          if (pressTimer !== null) {
            clearTimeout(pressTimer);
            pressTimer = null;
          }
        };
        // 添加事件监听器
        el.addEventListener('mousedown', start);
        el.addEventListener('touchstart', start);
        // 取消长按
        el.addEventListener('click', cancel);
        el.addEventListener('mouseout', cancel);
        el.addEventListener('touchend', cancel);
        el.addEventListener('touchcancel', cancel);
      }
    }
  },
  data() {
    return {
      loading: false,
      tmm: "hwh4J_2P9qaloG5VTNF_xkm9iRZIyuLF7H_Wt19lzTw=",
      search_keyword: "",
      expandedIndex: "",
      activeTab: "tab_ty_jiucai_search",
      swipeableEnabled: true, // 控制van-tabs的swipeable属性
      longPressDialog: false, // 长按弹窗相关，弹窗显示状态
      currentStockCode: "", // 长按弹窗相关，当前操作的
      currentStockName: "", // 长按弹窗相关，当前操作的
      popupTop: 0, // 长按弹窗相关，弹窗定位top
      popupLeft: 0, // 长按弹窗相关，弹窗定位left
      touchStartX: 0, // stock_name触摸开始X坐标
      touchStartY: 0, // stock_name触摸开始Y坐标
      tagsDialogVisible: false, // 标签编辑弹窗显示状态
      tagsStockCode: "", // 标签编辑弹窗，当前股票代码
      tagsStockName: "", // 标签编辑弹窗，当前股票名称
      tagsInputValue: "", // 标签编辑弹窗，输入框值
      keywords_history: [],
      xinde_result: [],
      tab_ty_jiucai_search: {},
      tab_ty_jiucai_search_result: [],
      // 初始化为包含空数组的结构，避免数据未加载时报错
      tab_tianti_result: {
        lianban_list_1: [],
        lianban_list_2: [],
        lianban_list_3: [],
        lianban_list_4: [],
        lianban_list_5: [],
        pre_lianban_list_1: [],
        pre_lianban_list_2: [],
        pre_lianban_list_3: [],
        pre_lianban_list_4: [],
      },
      tab_zhangfu_result: {
        zf_1_week_list: [],
        zf_2_weeks_list: [],
        zf_today_list_bj: [],
        zf_1_week_list_bj: [],
        zf_2_weeks_list_bj: [],
        zf_today_list_large: []
      },
      // Tab配置数组：集中管理标题、名称、数据键名
      tiantiTabConfigs: [
        { title: "一", name: "tab_tianti_1", listKey: ["lianban_list_1"] },
        { title: "二", name: "tab_tianti_2", listKey: ["lianban_list_2", "pre_lianban_list_1"], tips: "" },
        { title: "三", name: "tab_tianti_3", listKey: ["lianban_list_3", "pre_lianban_list_2"], tips: "" },
        { title: "四", name: "tab_tianti_4", listKey: ["lianban_list_4", "pre_lianban_list_3"], tips: "" },
        { title: "更高", name: "tab_tianti_5", listKey: ["lianban_list_5", "pre_lianban_list_4"], tips: "" }
      ],
      zhangfuTabConfigs: [
        { title: "今日(实时)", name: "tab_zhangfu_1", listKey: ["zf_today_list_large", "zf_today_list_bj"], tips: "关注大盘股、中军股的k线区间涨幅" },
        { title: "一周", name: "tab_zhangfu_2", listKey: ["zf_1_week_list", "zf_1_week_list_bj"], tips: "" },
        { title: "两周", name: "tab_zhangfu_3", listKey: ["zf_2_weeks_list", "zf_2_weeks_list_bj"], tips: "" },
      ],
      // 交易记录相关数据
      trade_records: [],
      trade_reasons: [],
      show_trade_dialog: false,
      trade_form: {
        id: '',
        trade_date: '',
        stock_name: '',
        buy_reason: '',
        advantage: '',
        disadvantage: '',
        profit_percent: ''
      },
      is_edit_mode: false,
      showReasonPicker: false,
      reasonPickerColumns: []
    };
  },
  mounted() {
    this.onBtnTyJiucaiSearch();
    this.fetchTianqiData();
    this.fetchZhangfuData();
    this.fetchTradeData();
    this.fetchTradeReasons();
  },
  methods: {
    handleResponse_list(response) {
      if (response.data.code === '0') {
        // 暂时注释掉
        // Notify({ type: 'success', duration: 300, message: '查询成功' });
        // return response.data.data;
        return response.data;
      } else {
        Notify({ type: 'warning', duration: 3000, message: `查询失败，${response.data.data}` });
        return []; // 失败时返回空数组，避免后续渲染报错
      }
    },
    handleException(error) {
      Notify({ type: 'danger', duration: 3000, message: error.message || '网络异常' });
    },
    assignment_common_params(tab_search) {
      tab_search.search_keyword = this.search_keyword;
    },
    async fetchTianqiData() {
      this.loading = true;
      this.$axios.post('/api/user/tianti/query')
        .then(response => {
          this.loading = false;
          this.tab_tianti_result = this.handleResponse_list(response)['data'];
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    async fetchZhangfuData() {
      this.loading = true;
      this.$axios.post('/api/user/zhangfu/query')
        .then(response => {
          this.loading = false;
          this.tab_zhangfu_result = this.handleResponse_list(response)['data'];
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    async onBtnTyJiucaiSearch() {
      this.loading = true;
      this.assignment_common_params(this.tab_ty_jiucai_search);
      this.$axios.post('/api/user/jiucai/query', this.tab_ty_jiucai_search)
        .then(response => {
          this.loading = false;
          const res_data = this.handleResponse_list(response);
          this.tab_ty_jiucai_search_result = res_data['data']
          this.keywords_history = res_data['keywords_history']
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    async onBtnTyJiucaiSearchAll() {
      this.loading = true;
      this.search_keyword = 'ALL'
      this.assignment_common_params(this.tab_ty_jiucai_search);
      this.$axios.post('/api/user/jiucai/query', this.tab_ty_jiucai_search)
        .then(response => {
          this.loading = false;
          const res_data = this.handleResponse_list(response);
          this.tab_ty_jiucai_search_result = res_data['data']
          this.keywords_history = res_data['keywords_history']
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    seeTyDetail(event, index_stock_code) {
        // 获取点击元素
        const element = event.currentTarget;
        // 记录点击前元素相对于视口顶部的偏移量
        const initialOffsetTop = element.getBoundingClientRect().top;

        // 展开或关闭
        if (this.expandedIndex === index_stock_code) {
            this.expandedIndex = ""; // 点击已展开的 item 则关闭
        } else {
            this.expandedIndex = index_stock_code; // 点击其他 item 则展开该 item 并关闭其他
        }

        // 在 DOM 更新后进行滚动调整
        this.$nextTick(() => {
            // 重新获取元素相对于视口顶部的偏移量
            const newOffsetTop = element.getBoundingClientRect().top;
            // 计算滚动差值
            const scrollDiff = newOffsetTop - initialOffsetTop;
            // 调整滚动位置
            window.scrollBy(0, scrollDiff);
        });
    },
    // 长按触发的方法
    handleLongPress(event, stockCode, stockName) {
      event.preventDefault();
      event.stopPropagation();
      // 1. 获取点击位置，计算弹窗定位（在长按位置下方显示）
      const clientX = event.clientX || event.touches[0].clientX;
      const clientY = event.clientY || event.touches[0].clientY;
      this.popupLeft = clientX - 80; // 左偏移居中
      this.popupTop = clientY + 20; // 下偏移避免遮挡手指
      // 2. 保存当前股票代码 + 显示弹窗
      this.currentStockCode = stockCode;
      this.currentStockName = stockName;
      this.longPressDialog = true;
    },
    // 操作人气的方法
    async operatePopularity(type) {
      // 关闭弹窗
      this.longPressDialog = false;
      // 构造请求参数
      const params = {
        stock_code: this.currentStockCode,
        stock_name: this.currentStockName,
        operation: type // 'add' 或 'remove'
      };
      // 调用后端Flask接口
      this.$axios.post('/api/user/renqi/set', params)
      .then(response => {
        const oper_obj = this.handleResponse_list(response)['data'];
        alert(type === 'add_renqi' ? oper_obj+'添加人气成功' : oper_obj+'移除人气成功');
      })
      .catch(error => {
        alert(type+' 失败')
        this.handleException(error);
      });
    },
    // 取消操作
    cancelOperate() {
      this.longPressDialog = false;
      this.currentStockCode = "";
      this.currentStockName = "";
    },
    // stock_name touchstart事件 - 记录触摸起始位置
    onStockNameTouchStart(e) {
      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    },
    // stock_name touchend事件 - 判断是点击还是滑动
    onStockNameTouchEnd(e, stockCode, stockName, tags) {
      const touch = e.changedTouches[0];
      const deltaX = Math.abs(touch.clientX - this.touchStartX);
      const deltaY = Math.abs(touch.clientY - this.touchStartY);
      // 移动距离小于15px视为点击
      if (deltaX < 15 && deltaY < 15) {
        e.stopPropagation();
        e.preventDefault();
        this.openTagsDialog(stockCode, stockName, tags);
      }
      // 否则是滑动，不做任何处理，让van-tabs正常切换
    },
    // 打开标签编辑弹窗
    openTagsDialog(stockCode, stockName, tags) {
      this.tagsStockCode = stockCode;
      this.tagsStockName = stockName;
      // 如果tags不为空，自动追加逗号方便继续输入
      this.tagsInputValue = tags ? tags + "," : "";
      this.tagsDialogVisible = true;
    },
    // 关闭标签编辑弹窗
    closeTagsDialog() {
      this.tagsDialogVisible = false;
      this.tagsStockCode = "";
      this.tagsStockName = "";
      this.tagsInputValue = "";
    },
    // 保存标签
    async saveTags() {
      // 构造请求参数
      const params = {
        stock_code: this.tagsStockCode,
        stock_name: this.tagsStockName,
        tags: this.tagsInputValue
      };

      this.$axios.post('/api/user/tags/set', params)
        .then(response => {
          const res_data = this.handleResponse_list(response);
          if (res_data.code === '0') {
            alert('标签保存成功');
            // 更新本地数据中的tags
            this.updateLocalTags(this.tagsStockCode, this.tagsInputValue);
            this.closeTagsDialog();
          }
        })
        .catch(error => {
          alert('标签保存失败');
          this.handleException(error);
        });
    },
    // 更新本地数据中的tags
    updateLocalTags(stockCode, newTags) {
      // 更新天梯数据
      for (const key in this.tab_tianti_result) {
        const list = this.tab_tianti_result[key];
        if (Array.isArray(list)) {
          const item = list.find(i => i.stock_code === stockCode);
          if (item) {
            this.$set(item, 'tags', newTags);
          }
        }
      }
      // 更新涨幅数据
      for (const key in this.tab_zhangfu_result) {
        const list = this.tab_zhangfu_result[key];
        if (Array.isArray(list)) {
          const item = list.find(i => i.stock_code === stockCode);
          if (item) {
            this.$set(item, 'tags', newTags);
          }
        }
      }
    },
    onBtnXindeClick(){
      this.$axios.get('/api/user/xinde/query')
      .then(response => {
          // 替换\n
          this.xinde_result = response.data['data'];
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    // 辅助方法：获取指定列表数据，避免模板中写复杂语法
    getTiantiList(listKey) {
      return this.tab_tianti_result[listKey] || [];
    },
    // 辅助方法：获取列表长度，避免模板中计算报错
    getTiantiListLength(listKey) {
      return this.getTiantiList(listKey).length;
    },
    // 辅助方法：获取指定列表数据，避免模板中写复杂语法
    getZhangfuList(listKey) {
      return this.tab_zhangfu_result[listKey] || [];
    },
    // 解决华为手机浏览器target="_blank"无效的问题
    // 强制新标签打开函数（适配华为浏览器）
    openNewTab(e, url) {
      // 1. 先阻止Vue事件的默认行为（关键：避免原生a标签跳转）
      e.preventDefault();
      e.stopPropagation(); // 防止van-tab等组件拦截事件

      // 2. 延迟触发（适配华为浏览器）
      setTimeout(() => {
        // 3. 强制打开新标签，补充noopener/noreferrer（华为浏览器必需）
        window.open(url, '_blank', 'noopener,noreferrer');
      }, 100);

      return false;
    },
    // 交易记录相关方法
    async fetchTradeData() {
      this.loading = true;
      this.$axios.post('/api/user/trade/query')
        .then(response => {
          this.loading = false;
          this.trade_records = this.handleResponse_list(response)['data'];
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    async fetchTradeReasons() {
      this.$axios.get('/api/user/trade/reasons')
        .then(response => {
          if (response.data.code === '0') {
            this.trade_reasons = response.data.data;
            this.updateReasonPickerColumns();
          }
        })
        .catch(error => {
          this.handleException(error);
        });
    },
    updateReasonPickerColumns() {
      this.reasonPickerColumns = this.trade_reasons;
    },
    openAddTradeDialog() {
      this.is_edit_mode = false;
      this.trade_form = {
        id: '',
        trade_date: this.getCurrentDate(),
        stock_name: '',
        buy_reason: '',
        advantage: '',
        disadvantage: '',
        profit_percent: ''
      };
      this.show_trade_dialog = true;
    },
    openEditTradeDialog(item) {
      this.is_edit_mode = true;
      this.trade_form = {
        id: item.id,
        trade_date: item.trade_date,
        stock_name: item.stock_name,
        buy_reason: item.buy_reason,
        advantage: item.advantage,
        disadvantage: item.disadvantage,
        profit_percent: item.profit_percent
      };
      this.show_trade_dialog = true;
    },
    closeTradeDialog() {
      this.show_trade_dialog = false;
    },
    onReasonConfirm(value) {
      this.trade_form.buy_reason = value;
      this.showReasonPicker = false;
    },
    async saveTradeRecord() {
      if (!this.trade_form.trade_date) {
        Notify({ type: 'warning', message: '请输入交易日期' });
        return;
      }
      this.loading = true;
      const url = this.is_edit_mode ? '/api/user/trade/update' : '/api/user/trade/add';
      this.$axios.post(url, this.trade_form)
        .then(response => {
          this.loading = false;
          if (response.data.code === '0') {
            Notify({ type: 'success', message: '保存成功' });
            this.closeTradeDialog();
            this.fetchTradeData();
            this.fetchTradeReasons();
          } else {
            Notify({ type: 'warning', message: '保存失败' });
          }
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    async deleteTradeRecord() {
      Dialog.confirm({
        title: '确认删除',
        message: '确定要删除这条交易记录吗？'
      }).then(() => {
        this.loading = true;
        this.$axios.post('/api/user/trade/delete', { id: this.trade_form.id })
          .then(response => {
            this.loading = false;
            if (response.data.code === '0') {
              Notify({ type: 'success', message: '删除成功' });
              this.closeTradeDialog();
              this.fetchTradeData();
            } else {
              Notify({ type: 'warning', message: '删除失败' });
            }
          })
          .catch(error => {
            this.loading = false;
            this.handleException(error);
          });
      }).catch(() => {});
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getProfitLossClass(percent) {
      if (!percent) return '';
      if (percent.startsWith('+')) return 'red-text';
      if (percent.startsWith('-')) return 'green-text';
      return '';
    },
    formatTradeDate(dateStr) {
      if (!dateStr) return '';
      // 将 YYYY-MM-DD 格式转换为 MM-DD
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        return `${parts[1]}-${parts[2]}`;
      }
      return dateStr;
    }
  }
};
</script>

<style lang="less">
.tips_zone {
  margin: 10px;
}

.tip_zone {
  margin: 10px 10px 30px;
}

.mgt20 {
  margin: 10px 0;
}

.add_input {
  text-align: right;
  margin: 0 10px;
}

.checkbox_zone {
  display: flex;
  justify-content: left;
}

.radio_zone {
  display: flex;
  justify-content: left;
}

.btn_zone {
  display: flex;
  justify-content: space-around;

  button {
    width: 100px;
  }
}

.jiucai_zone {
  margin: 10px;
  font-size: 18px;
}

p {
  margin: 0 10px;
  padding: 0;
}

.even-item {
  background-color: #FDEDEC; /* 偶数行背景色，粉色 */
  padding: 10px 0px;
}

.odd-item {
  background-color: #EAFAF1; /* 奇数行背景色，绿色 */
  padding: 10px 0px;
}

.zf-even-item {
  background-color: #FDEDEC; /* 偶数行背景色，粉色 */
  padding: 2px 0px;
}

.zf-odd-item {
  background-color: #EAFAF1; /* 奇数行背景色，绿色 */
  padding: 2px 0px;
}

.blue-label .van-radio__label {
  color: #2ab5e6;
}

.red-text { color: red; }
.green-text { color: green; }
.blue-text { color: #2ab5e6; }

.black-link {
  color: black;  /* 文字颜色设为黑色 */
  text-decoration: none;  /* 可选：去除默认下划线 */
}

/* 已访问后的样式（关键：恢复点击后变色） */
.black-link:visited {
  color: #609; /* 浏览器默认的已访问颜色（紫色系），可自定义 */
}

/* 新增：加载层样式 */
.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5); /* 半透明背景，遮挡内容更明显 */
}

.loading-content {
  text-align: center;
  color: #fff;
}

.loading-text {
  margin-top: 10px;
  font-size: 14px;
}

/* 自定义长按弹窗样式 */
.longpress-popup {
  position: fixed;
  z-index: 9999; /* 确保弹窗在最上层 */
  pointer-events: none; /* 让mask接收点击 */
}

.longpress-popup .popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}

.longpress-popup .popup-content {
  position: relative;
  z-index: 10;
  display: flex;
  gap: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}

/* 按钮样式优化 */
.popup-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.add-btn {
  background: #4cd964;
  color: #fff;
}

.add-btn:hover {
  background: #3bc853;
}

.remove-btn {
  background: #ff6b6b;
  color: #fff;
}

.remove-btn:hover {
  background: #ff5252;
}

/* 防止按钮点击穿透 */
.popup-btn:active {
  transform: scale(0.98);
}

/* 标签显示样式 */
.stock-name-clickable {
  cursor: pointer;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.tags-display {
  margin-left: 2px;
}

.tag-item {
  font-size: 10px;
  color: #ff9800;
  margin-left: 2px;
  padding: 0 2px;
  background-color: #fff3e0;
  border-radius: 2px;
}

/* 标签编辑弹窗样式 */
.tags-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tags-dialog {
  width: 85%;
  max-width: 350px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.tags-dialog-title {
  padding: 15px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.tags-dialog-content {
  padding: 10px 0;
}

.tags-dialog-footer {
  display: flex;
  justify-content: space-around;
  padding: 10px 15px 15px;
  gap: 10px;
}

.tags-dialog-footer .van-button {
  flex: 1;
}

/* 交易记录样式 */
.trade_zone {
  margin: 10px;
}

.trade_list {
  margin: 10px 0;
}

.trade-dialog {
  width: 90%;
  max-width: 400px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  max-height: 80vh;
  overflow-y: auto;
}

</style>